import axios from 'axios'
import router from './router'
import store from './store'

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://crm.oddab.eu/api/' : ''

axios.interceptors.request.use(function (config) {
  const token = window.localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

axios.interceptors.response.use(response => response, error => {
  if (error.response.status === 403) {
    store.dispatch('logout')
    router.push('/login')
  }

  return Promise.reject(error);
});

const appService = {
  searchCustomers(search) {
    return new Promise((resolve, reject) => {
      axios.get(`/customers?find=${search}`)
      .then(result => resolve(result.data))
      .catch(() => reject('Sökningen misslyckades'))
    })
  },

  getCustomer (id) {
    return axios.get('/customers/' + id).then(res => res.data)
  },

  getCustomerFull (id) {
    return axios.get(`/customers/${id}/full`).then(res => res.data)
  },

  saveCustomer(customer) {
    return new Promise((resolve, reject) => {
      axios.put(`/customers/${customer.CustomerId}`, customer)
      .then(res => resolve(res.data))
      .catch(err => reject(err.response.data))
    })
  },

  createCustomer (customer) {
    return axios.post('/customers', customer).then(res => res.data)
  },

  getContact (id) {
    return axios.get('/contacts/' + id).then(res => res.data)
  },

  searchContacts(search) {
    return new Promise((resolve, reject) => {
      axios.get(`/contacts?find=${search}`)
      .then(result => resolve(result.data))
      .catch(() => reject('Sökningen misslyckades'))
    })
  },

  updateContact (id, contact) {
    return axios.put('/contacts/' + id, contact).then(res => res.data)
  },

  createContact (contact) {
    return axios.post('/contacts', contact).then(res => res.data)
  },

  deleteContact (id) {
    return axios.delete('/contacts/' + id).then(res => res.data)
  },

  createNote (note) {
    return axios.post('/notes', note)
  },

  updateNote (note) {
    return new Promise((resolve, reject) => {
      axios.put(`/notes/${note.CustomerNoteId}`, note)
      .then(res => resolve(res.data))
      .catch(err => reject(err.response.data))
    })
  },

  deleteNote (id) {
    return axios.delete('/notes/' + id).then(res => res.data)
  },

  getNote (id) {
    return axios.get(`/notes/${id}`).then(res => res.data)
  },

  getNotification (id) {
    return axios.get(`/notifications/${id}`).then(res => res.data)
  },

  createNotification (notification) {
    return axios.post('/notifications', notification)
  },

  updateNotification (notification) {
    return axios.put(`/notifications/${notification.MessageId}`, notification)
  },

  deleteNotification (id) {
    return axios.delete(`/notifications/${id}`)
  },

  getCountries () {
    return axios.get('/countries').then(res => res.data)
  },

  searchOutlookContacts(search) {
    return axios.get(`/outlook-contacts?search=${search}`).then(res => res.data.value)
  },

  getOutlookContact(id) {
    return axios.get(`/outlook-contacts/${id}`).then(res => res.data)
  },

  getUsers() {
    return axios.get('/users').then(res => res.data)
  },

  login (credentials) {
    return new Promise((resolve, reject) => {
      axios.post('/authenticate', credentials)
      .then(res => resolve(res.data))
      .catch(res => reject(res.response.data))
    })
  }
}

export default appService



// WEBPACK FOOTER //
// ./src/appService.js